import React from 'react';
import DataTableWrapper from '../DataTableWrapper';

const RbskDataTable = ({ records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage }) => {
    return (
        <DataTableWrapper
            loading={loading} currentPage={currentPage} setCurrentPage={setCurrentPage}
            totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
        >
            <table className="table table-striped table-hover table-bordered align-middle text-center mb-0" style={{ fontSize: 13 }}>
                <thead>
                    <tr>
                        <th rowSpan={2}>Sr. No.</th>
                        <th rowSpan={2}>Reporting Date</th>
                        <th rowSpan={2}>State Name</th>
                        <th rowSpan={2}>District Name</th>
                        {/* <th rowSpan={2} className="section-divider">Health Block</th> */}
                        <th colSpan={4} className="cohort-header-children">Children (6 Months-18 Years)</th>
                    </tr>
                    <tr>
                        <th className="cohort-children">Non Anaemic</th>
                        <th className="cohort-children">Mild</th>
                        <th className="cohort-children">Moderate</th>
                        <th className="cohort-children">Severe</th>
                    </tr>
                </thead>
                <tbody>
                    {records.map((r, idx) => (
                        <tr key={r.id || idx}>
                            <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                            <td>{r.report_date}</td>
                            <td>{r.state_name}</td>
                            <td><strong className="text-body">{r.district_name}</strong></td>
                            {/* <td className="section-divider">{r.block_name || "-"}</td> */}

                            <td className="cohort-children">{r.ch_6to18m_normal || 0}</td>
                            <td className="cohort-children">{r.ch_6to18m_mild || 0}</td>
                            <td className="cohort-children">{r.ch_6to18m_moderate || 0}</td>
                            <td className="cohort-children color-severe">{r.ch_6to18m_severe || 0}</td>
                        </tr>
                    ))}
                    {records.length === 0 && (
                        <tr>
                            <td colSpan={9} className="text-center py-4 text-muted">
                                No records match the current filters.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </DataTableWrapper>
    );
};

export default RbskDataTable;
